<div class="action-tablet">

  <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
    <ng-container *ngIf="enableStationSelectionHeader">
      <app-action-tablet-header [actionTabletContext]="actionTabletContext"></app-action-tablet-header>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
    </ng-container>

    <sc-flex-fitting-content [vertical]="true">

      <sc-tab-group>

        <ng-template tabGroupRightToolbar>
            <sc-action-icon iconClass="fa-lock fa" (click)="startSuspension()"
                *ngIf="selectedStation?.stationUsage.transports.length === 0 && !selectedStation?.stationUsage.disabled && !selectedStation?.stationUsage.loadingZoneLock">
            </sc-action-icon>
        </ng-template>

        <sc-tab iconCss="fa-desktop" titleDictionaryKey="tmc-yard.action-tablet.station-transport-details.title">
          <sc-content-spacer vertical></sc-content-spacer>
          <app-action-tablet-station-details
            [stationId]="actionTabletContext.currentlyActiveStation"></app-action-tablet-station-details>
        </sc-tab>

        <sc-tab iconCss="fa-truck-flatbed" titleDictionaryKey="tmc-yard.action-tablet.waiting-movement-orders.title">
          <sc-content-spacer vertical></sc-content-spacer>
          <app-action-tablet-waiting-movement-orders
            [movementOrders]="waitingMovementOrders"></app-action-tablet-waiting-movement-orders>
        </sc-tab>

      </sc-tab-group>

    </sc-flex-fitting-content>

  </sc-flex>

</div>